module.exports = __webpack_public_path__ + "static/media/Timber Batons superwood.23d53398.jpg";